/**
 * AdminCreatedBadge — visible chip rendered on matches that were
 * injected by an admin via POST /v1/admin/matches.
 *
 * Surfaces:
 *   - The admin-injection reason
 *   - Whether dealbreakers were force-bypassed
 *
 * Spec: docs/superpowers/specs/2026-05-28-admin-matches-summaries-design.md §7.2
 */
interface Props {
  match: {
    admin_create_reason?: string | null;
    admin_create_force_dealbreakers?: boolean;
  };
}

export function AdminCreatedBadge({ match }: Props) {
  return (
    <div className="mb-2 rounded-md border border-destructive bg-destructive/10 px-2.5 py-2 text-[13px] text-destructive">
      <strong>🔧 Admin-created</strong>
      <span className="ml-1.5">
        reason: <em>{match.admin_create_reason || '—'}</em>
      </span>
      {match.admin_create_force_dealbreakers && (
        <span className="ml-1.5 font-semibold text-red-500">
          · ⚠ dealbreakers bypassed
        </span>
      )}
    </div>
  );
}
